import { checkIsChildArr } from '../services/helper';
import { orderStatus, FulfillOption as FulfillOptionConst } from './../constants';
import { GET_LIST_CHANNEL_ORDER_SUCCESS } from './../actions/ordersAction'

const initState = {
    add_filter: false,
    input_filter: {
        status_list: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
        from: undefined,
        to: undefined,
        type_list: [],
        channel: [],
        fulfill_option:[orderStatus.FULFILLMENT_YAMATO, orderStatus.FULFILLMENT_IN_HOUSE],
    },
    sub_input_filter: {
        status_list: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
        from: undefined,
        to: undefined,
        type_list: [],
        channel: [],
        maxTagCount: 2
    },
    orders: [],
    orderBy: 'OrderDT',
    isDesc: true,
    checkedOrders: [],
    listIdCheckedOrders: [],
    listIdCheckedOrdersWithStatus: {},
    listIdCheckedOrderWithFulfillOption: {},
    getting_order: false,
    isCheckedAll: false,
    offset: 50,
    current_page: 1,
    pages: 0,
    filter_count_status: {
        7: undefined,
        8: undefined,
        9: undefined,
        17: undefined
    },
    lastUpdateTime: '',
    listChannel: [],
    showImportOrder: false,
    splitedOrder: {},
}

const letSticky = () => {
    let header = document.getElementById("static-top");
    let topHeight = document.getElementById("header").clientHeight;
    // Get the offset position of the navbar
    let sticky = header.offsetTop;
    return { header, topHeight, sticky }
}

const removeFilter = () => {
    if (window.pageYOffset > letSticky().sticky + letSticky().topHeight) {
        letSticky().header.classList.add("sticky");
        letSticky().header.classList.remove("sticky-filter");
    }
}

const addFilter = () => {
    if (window.pageYOffset > letSticky().sticky + letSticky().topHeight) {
        letSticky().header.classList.add("sticky-filter");
        letSticky().header.classList.remove("sticky");
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'RESET_SUMARY_ORDER': 
            return {
                ...state, 
                AwaitingFinalizationTotal: 0
            }
        case 'ON_LOAD_ORDERS':
            return { ...state, orders: action.payload }
        case 'ADD_FILTER':
            if (!state.add_filter) {
                removeFilter()
                let copy = { ...state }
                return {
                    ...state,
                    add_filter: true,
                    input_filter: copy.input_filter,
                }
            } else {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0;
                addFilter()
                let copy = { ...state }
                return {
                    ...state,
                    add_filter: false,
                    input_filter: copy.input_filter,
                }
            }
        case 'CLOSE_FILTER_ORDER': {
            removeFilter()
            let copy = { ...state }
            return {
                ...state,
                add_filter: false,
            }
        }
        case 'ON_CHANGE':
            let copy = { ...state }
            let result = {
                ...state,
                sub_input_filter: {
                    ...copy.sub_input_filter,
                    [action.payload.column]: action.payload.value,
                }
            }
            return result
        case 'ON_SUBMIT': {
            let copy = { ...state }
            if (action.payload.isKeepState) {
                return {
                    ...state, getting_order: true, input_filter: copy.sub_input_filter
                }
            } else if (action.payload.isChangeOffset) {
                return {
                    ...state, getting_order: true, input_filter: copy.input_filter
                }
            } else {
                return {
                    ...state, getting_order: true, isDesc: true, orderBy: 'OrderDT', current_page: 1, input_filter: copy.sub_input_filter,
                    listIdCheckedOrders: [],
                }
            }
        }

        case 'ON_SORT': {
            let result
            let copy = { ...state }
            let columns = ['ChannelID', 'ChannelOrderID', 'OrderDT', 'ConsigneeNameCH', 'DestinationCountryCH', 'StatusID']

            columns.map(column => {
                if (action.payload.reload) {
                    result = {
                        ...state,
                        getting_order: true,
                    }
                } else if (!action.payload.reload) {
                    if (action.payload.column == column && action.payload.column == copy.orderBy) {
                        result = {
                            ...state,
                            orderBy: column,
                            isDesc: !copy.isDesc,
                            getting_order: true,
                        }
                    }
                    if (action.payload.column == column && action.payload.column != copy.orderBy) {
                        result = {
                            ...state,
                            orderBy: column,
                            isDesc: true,
                            getting_order: true,
                        }
                    }
                }
            })
            return result
        }
        case 'ON_GET_ORDERS_BY_PAGE': {
            return {
                ...state,
                current_page: action.payload.current_page,
                getting_order: true,
            }
        }

        case 'UPDATE_ORDER_LIST': {
            let copy = { ...state }
            return {
                ...state,
                offset: action.payload.offset ? action.payload.offset : copy.offset,
                input_filter: {
                    ...copy.input_filter,
                    status_list: action.payload.input_filter ? action.payload.input_filter.status_list : copy.input_filter.status_list,
                    channel_order_no: action.payload.input_filter ? action.payload.input_filter.channel_order_no : copy.input_filter.channel_order_no,
                    channel: action.payload.input_filter ? action.payload.input_filter.channel : copy.input_filter.channel,
                    from: action.payload.input_filter ? action.payload.input_filter.from : copy.input_filter.from,
                    to: action.payload.input_filter ? action.payload.input_filter.to : copy.input_filter.to,
                    type_list: action.payload.input_filter ? action.payload.input_filter.type_list : copy.input_filter.type_list,
                    fulfill_option: action.payload.input_filter ? action.payload.input_filter.fulfill_option : copy.input_filter.fulfill_option,
                },
                add_filter: action.payload.add_filter,
                orderBy: action.payload.orderBy ? action.payload.orderBy : copy.orderBy
            }
        }

        case 'GET_ORDERS_SUCCESS': {
            let copy = { ...state }
            let newDataOrders = []
            for (let i = 0; i < action.json.data.data.SearchOrderResults.length; i++) {
                action.json.data.data.SearchOrderResults[i].key = i
                newDataOrders.push(action.json.data.data.SearchOrderResults[i])
            }
            for (let i in copy.listIdCheckedOrdersWithStatus) {
                if (!action.json.data.data.SelectedIds.includes(parseInt(i))) {
                    delete copy.listIdCheckedOrdersWithStatus[i]
                    delete copy.listIdCheckedOrderWithFulfillOption[i]
                }
            }
            return {
                ...state,
                sub_input_filter: copy.input_filter,
                orders: newDataOrders,
                getting_order: false,
                pages: action.json.data.data.PageCount,
                order_count: action.json.data.data.OrderCount,
                current_page: copy.current_page > action.json.data.data.PageCount ? action.json.data.data.OrderCount : copy.current_page,
                checkedOrders: [],
                isCheckedAll: false,
                AwaitingFinalizationTotal: action.json.data.data.AwaitingFinalizationCount,
                AwaitingShipmentTotal: action.json.data.data.AwaitingShipmentCount,
                // FulfillmentCountInHouse: action.json.data.data.OrderInHouseCountFilter,
                // FulfillmentCountYamato: action.json.data.data.OrderYamatoCountFilter,
                filter_count_status: {
                    7: action.json.data.data.AwaitingFinalizationCountByFilter,
                    8: action.json.data.data.AwaitingShipmentCountByFilter,
                    9: action.json.data.data.SentToShipmentCountByFilter,
                    17: action.json.data.data.SplitCountByFilter
                },
                filter_count_type: {
                    1: action.json.data.data.ImportCountByFilter,
                    2: action.json.data.data.ManualCountByFilter,
                },
                filter_count_fulfillment: {
                    1: action.json.data.data.OrderInHouseCountFilter,
                    2: action.json.data.data.OrderYamatoCountFilter,
                },
                listIdCheckedOrders: action.json.data.data.SelectedIds,
                listIdCheckedOrdersWithStatus: copy.listIdCheckedOrdersWithStatus,
                listIdCheckedOrderWithFulfillOption: copy.listIdCheckedOrderWithFulfillOption
            }
        }
        case 'GET_ORDERS_FAILURE': {
            return { ...state, orders: [], getting_order: false }
        }
        case 'ON_CHECK_ORDER': {
            let result
            let copy = { ...state }
            let key = parseInt(Object.keys(action.payload)[0])
            let index = copy.checkedOrders.indexOf(key)
            let isCheckedAll
            let listIdCheckedOrdersWithStatus = copy.listIdCheckedOrdersWithStatus
            let listIdCheckedOrderWithFulfillOption = copy.listIdCheckedOrderWithFulfillOption
            listIdCheckedOrdersWithStatus[action.payload[key]] = copy.orders[key].StatusID
            listIdCheckedOrderWithFulfillOption[action.payload[key]] = copy.orders[key].FulfillmentOption;
            if (index > -1) {
                delete listIdCheckedOrdersWithStatus[action.payload[key]]
                delete listIdCheckedOrderWithFulfillOption[action.payload[key]]
                result = {
                    ...state,
                    checkedOrders: copy.checkedOrders.filter(value => value != key),
                    listIdCheckedOrders: copy.listIdCheckedOrders.filter(value => value != parseInt(action.payload[key])),
                    isCheckedAll: false
                }
            } else {
                if (copy.checkedOrders.length == copy.orders.length - 1) {
                    isCheckedAll = true
                }
                else {
                    isCheckedAll = false
                }
                if (copy.listIdCheckedOrders.indexOf(action.payload[key]) > -1) {
                    delete listIdCheckedOrdersWithStatus[action.payload[key]]
                    delete listIdCheckedOrderWithFulfillOption[action.payload[key]]
                    result = {
                        ...state,
                        checkedOrders: [...copy.checkedOrders, key],
                        listIdCheckedOrders: copy.listIdCheckedOrders.filter(value => value != parseInt(action.payload[key])),
                        listIdCheckedOrdersWithStatus: listIdCheckedOrdersWithStatus,
                        listIdCheckedOrderWithFulfillOption: listIdCheckedOrderWithFulfillOption,
                        isCheckedAll,
                    }
                } else {
                    result = {
                        ...state,
                        checkedOrders: [...copy.checkedOrders, key],
                        listIdCheckedOrders: [...copy.listIdCheckedOrders, action.payload[key]],
                        listIdCheckedOrdersWithStatus: listIdCheckedOrdersWithStatus,
                        listIdCheckedOrderWithFulfillOption: listIdCheckedOrderWithFulfillOption,
                        isCheckedAll,
                    }
                }
            }
            return result
        }
        case 'ON_CHECK_ALL_ORDER': {
            let result
            let copy = { ...state }
            let listIdCheckedOrders = []
            let listIdCheckedOrdersWithStatus = copy.listIdCheckedOrdersWithStatus
            let listIdCheckedOrderWithFulfillOption = copy.listIdCheckedOrderWithFulfillOption
            copy.orders.forEach(order => {
                listIdCheckedOrders.push(order.ID)
                listIdCheckedOrdersWithStatus[order.ID] = order.StatusID
                listIdCheckedOrderWithFulfillOption[order.ID] = order.FulfillmentOption;
            })
            let lists = [...copy.listIdCheckedOrders]
            let isChildArr = checkIsChildArr(copy.listIdCheckedOrders, listIdCheckedOrders)
            if (!isChildArr) {
                lists = [...new Set(lists.concat(listIdCheckedOrders))]
            } else {
                lists.forEach((elm, idx) => {
                    if (listIdCheckedOrders.indexOf(elm) !== -1) {
                        delete lists[idx]
                        delete listIdCheckedOrdersWithStatus[elm]
                        delete listIdCheckedOrderWithFulfillOption[elm]
                    }
                })
                lists = lists.filter(value => value)
            }

            result = {
                ...state,
                checkedOrders: [],
                isCheckedAll: !isChildArr,
                listIdCheckedOrders: lists,
                listIdCheckedOrdersWithStatus: listIdCheckedOrdersWithStatus,
                listIdCheckedOrderWithFulfillOption: listIdCheckedOrderWithFulfillOption
            }
            return result
        }
        case 'ON_CHANGE_OFFSET_ORDER_LIST': {
            return { ...state, offset: action.payload, current_page: 1 }
        }
        case 'ON_NEXT_OR_BACK_ORDER': {
            let copy = { ...state }
            let result
            if (action.payload.type == 'back') {
                result = {
                    ...state,
                    current_page: copy.current_page - 1,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'back-head') {
                result = {
                    ...state,
                    current_page: 1,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'next') {
                result = {
                    ...state,
                    current_page: copy.current_page + 1,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'next-last') {
                result = {
                    ...state,
                    current_page: copy.pages,
                    getting_order: true,
                }
            }
            return result
        }
        case 'ON_RESET_ORDER_FILTER': {
            return {
                ...state,
                input_filter: {
                    type_list: [],
                    from: undefined,
                    to: undefined,
                    status_list: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
                    channel: [],
                    fulfill_option:[],
                },
                getting_order: true,
                current_page: 1,
                orderBy: 'OrderDT',
                isDesc: true,
                listIdCheckedOrders: [],
                listIdCheckedOrdersWithStatus: {},
                listIdCheckedOrderWithFulfillOption: {}
            }
        }
        case 'ON_REMOVE_FILTER_ORDER': {
            let result
            let copy = { ...state }
            if (Number.isInteger(action.payload.value)) {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        status_list: copy.input_filter.status_list.filter(a => a !== action.payload.value),
                    },
                }
            }
            if (action.payload.value == 'from') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        from: undefined,
                    },
                }
            }
            if (action.payload.value == 'to') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        to: undefined,
                    },
                }
            }
            if (action.payload.value == 'channel_order_no') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        channel_order_no: undefined,
                    },
                }
            }
            if (action.payload.value == 'channel') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        channel: undefined,
                    },
                }
            }
            return result
        }
        case 'ON_TAB_ORDER': {
            return {
                ...state,
                active_tab: action.payload.tab,
                input_filter: {
                    type_list: [],
                    status_list: [parseInt(action.payload.tab)],
                },
                current_page: 1,
                orderBy: 'OrderDT',
                getting_order: true,
                listIdCheckedOrders: [],
                listIdCheckedOrdersWithStatus: {},
                listIdCheckedOrderWithFulfillOption:{}
            }
        }
        case 'CREAT_SHIPMENT_SUCCESS': {
            return {
                ...state,
                create_shipment_success: true,
                getting_order: false,
            }
        }
        case 'CREAT_SHIPMENT_FAILURE': {
            return {
                ...state,
                getting_order: false,
            }
        }
        case 'ON_OK_CREATE_SHIPMENT': {
            return {
                ...state,
                create_shipment_success: false,
                create_shipment_failure: false,
                delete_order_success: false,
                delete_order_failure: false,
                listIdCheckedOrders: [],
                listIdCheckedOrdersWithStatus: {},
                listIdCheckedOrderWithFulfillOption: {},
                current_page: 1,
            }
        }
        case 'ON_DELETE_ORDER': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'DELETE_ORDER_SUCCESS': {
            return {
                ...state,
                delete_order_success: true,
                current_page: 1,
                listIdCheckedOrders: [],
                listIdCheckedOrdersWithStatus: {},
                listIdCheckedOrderWithFulfillOption: {},
                getting_order: false,
            }
        }
        case 'DELETE_ORDER_FAILURE': {
            return {
                ...state,
                delete_order_failure: true,
                getting_order: false,
            }
        }
        case 'ON_CREATE_SHIPMENT': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'GET_HEADER_SUMMARY_SUCCESS': {
            return {
                ...state,
                lastUpdateTime: action.payload.data.data.LastSyncUTC,
                AwaitingFinalizationTotal: action.payload.data.data.Error
            }
        }
        case 'GET_HEADER_SUMMARY_SHIPPER_NOT_FOUND': {
            return {
                ...state,
                AwaitingFinalizationTotal: 0
            }
        }
        case 'GET_HEADER_SUMMARY_ERROR': {
            return {
                ...state,
                AwaitingFinalizationTotal: 0
            }
        }

        case 'GET_SPLIT_ORDER': {
            return {
                ...state,
                getting_order: true
            }
        }

        case 'GET_SPLIT_ORDER_SUCCESS': {
            return {
                ...state,
                splitedOrder: action.payload.data.data,
                getting_order: false
            }
        }

        case 'GET_SPLIT_ORDER_FAILURE': {
            return {
                ...state,
                splitedOrder: {},
                getting_order: false
            }
        }

        case 'SYNC_ORDERS_SUCCESS':
            return {
                ...state,
                lastUpdateTime: action.json.data.data.LastSync,
                getting_order: false
            }

        case GET_LIST_CHANNEL_ORDER_SUCCESS:
            return {
                ...state,
                listChannel: action.payload.data.data.channels
            }

        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/ordersReducer.js